import { splitProps, type Component } from 'solid-js';

// Panel — the standard surface wrapper for a top-level feature pane (chart,
// activities, watchlist, companies). Owns the two design-token decisions every
// pane shares: the surface fill and the theme radius. Layout (flex direction,
// sizing, overflow, positioning) stays per-site via the class prop, since the
// panes differ. No overflow clipping by default, so a top or bottom child that
// wants to sit flush with the corners still rounds its own two.
//
// Naming a utility class in a comment here would emit it — Tailwind scans these
// files whole, comments included.

const baseClasses = 'bg-background rounded h-full flex flex-col w-full overflow-hidden';

function mergeClasses(...classes: (string | undefined)[]): string {
    return classes.filter(Boolean).join(' ');
}

export interface PanelProps {
    class?: string;
    children?: any;
    ref?: HTMLDivElement | ((el: HTMLDivElement) => void);
    [key: string]: any;
}

const Panel: Component<PanelProps> = (props) => {
    const [local, others] = splitProps(props, ['class', 'ref', 'children']);

    const classes = () => mergeClasses(baseClasses, local.class);

    return (
        <div class={classes()} ref={local.ref} {...others}>
            {local.children}
        </div>
    );
};

export { Panel };
